// extracted by mini-css-extract-plugin
export default {"actions":"_74baba60ebbb4693","action":"f6d853a857607174"};